// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClassicFooter_wrapper__A18dF"};